import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faCheck,
	faEnvelope,
	faHourglassHalf,
	faPaperPlane,
	faTimes,
} from "@fortawesome/free-solid-svg-icons"
import { COLORS } from "../../utilities/Constants"
import {
	EMAIL_STATUS_READY_TO_SEND,
	EMAIL_STATUS_SENDING,
	EMAIL_STATUS_SENT,
} from "../../utilities/Addons"

// Historique des e-mails d'une fiche (atelier ou dépannage — GE-25) : liste de
// cartes (et non un tableau), adaptée à la colonne étroite (flex:1) que
// partagent Documents / Restitution / E-mails. Chaque carte : modèle utilisé +
// badge de statut, puis destinataire + date, et le message d'erreur éventuel
// pour les envois échoués.

const statusOf = (status) => {
	if (status === EMAIL_STATUS_SENT)
		return {
			label: "Envoyé",
			color: COLORS.success,
			bg: COLORS.successLight,
			icon: faCheck,
		}
	if (status === EMAIL_STATUS_READY_TO_SEND)
		return {
			label: "En attente",
			color: COLORS.warning,
			bg: COLORS.warningLight,
			icon: faHourglassHalf,
		}
	if (status === EMAIL_STATUS_SENDING)
		// Claim SvpCentral pendant l'envoi SMTP : état transitoire (quelques secondes
		// en temps normal ; un SENDING durable = run interrompu, repassé en Échec
		// « vérifier réception » au run suivant par email_sender).
		return {
			label: "Envoi en cours",
			color: COLORS.accent,
			bg: COLORS.accentLight,
			icon: faPaperPlane,
		}
	return {
		label: "Échec",
		color: COLORS.danger,
		bg: COLORS.dangerLight,
		icon: faTimes,
	}
}

const ellipsis = {
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
}

const EmailListV2 = ({ emails }) => {
	if (!emails || emails.length === 0) return null

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: 8,
				marginBottom: 12,
			}}
		>
			{emails.map((es) => {
				const st = statusOf(es.status)
				const failed = es.status !== EMAIL_STATUS_SENT
				return (
					<div
						key={`email_${es.id}`}
						style={{
							border: `1px solid ${COLORS.border}`,
							borderLeft: `3px solid ${st.color}`,
							borderRadius: 8,
							backgroundColor: COLORS.surface,
							padding: "8px 10px",
						}}
					>
						{/* Ligne 1 : type d'e-mail + badge de statut */}
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 8,
							}}
						>
							<span
								style={{
									fontWeight: 600,
									fontSize: 13,
									color: COLORS.text,
									...ellipsis,
								}}
							>
								{es.template_label}
							</span>
							<span
								style={{
									flexShrink: 0,
									display: "inline-flex",
									alignItems: "center",
									gap: 5,
									padding: "2px 8px",
									borderRadius: 999,
									fontSize: 11,
									fontWeight: 600,
									color: st.color,
									backgroundColor: st.bg,
								}}
							>
								<FontAwesomeIcon
									icon={st.icon}
									style={{ fontSize: 10 }}
								/>
								{st.label}
							</span>
						</div>

						{/* Ligne 2 : destinataire + date d'envoi */}
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 8,
								marginTop: 5,
								fontSize: 11.5,
								color: COLORS.textMuted,
							}}
						>
							<span
								title={es.recipient}
								style={{
									display: "inline-flex",
									alignItems: "center",
									gap: 5,
									minWidth: 0,
									...ellipsis,
								}}
							>
								<FontAwesomeIcon
									icon={faEnvelope}
									style={{
										fontSize: 10,
										color: COLORS.textLight,
									}}
								/>
								<span style={ellipsis}>{es.recipient}</span>
							</span>
							<span style={{ flexShrink: 0 }}>{es.sent_at}</span>
						</div>

						{/* Message d'erreur éventuel */}
						{failed && es.error_message && (
							<div
								style={{
									marginTop: 6,
									fontSize: 11,
									color: COLORS.danger,
									lineHeight: 1.4,
								}}
							>
								{es.error_message}
							</div>
						)}
					</div>
				)
			})}
		</div>
	)
}

export default EmailListV2
